import React, { useEffect, useRef, useState } from 'react';
import bgImage1 from '../img/call-of-duty-modern-warfare-2-2022-games-call-of-duty-3840x2160-8571.jpg';
import bgImage2 from '../img/dark-elden-ring-4k.jpg';
import bgImage3 from '../img/410070.jpg';
import bgImage4 from '../img/image.png';
import bgImage5 from '../img/wolf-sekiro-shadows-3840x2160-14178.jpg';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/all';
import Earth from '../components/Earth';
import SplitType from 'split-type';
import img1 from '../img/1.jpg'
import img2 from '../img/float1.jpg'
import img3 from '../img/3.jpg'
import img4 from '../img/2-.jpg'
import img5 from '../img/5.jpg'
import img6 from '../img/6.jpg'
import img7 from '../img/7.jpg'
import img8 from '../img/8.png'
import img9 from '../img/9+.jpg'
import img10 from '../img/10.jpg'
import img11 from '../img/11.jpg'
import img12 from '../img/12.jpg'
import styles from '../components/style.module.scss';
import Magnetic from '../components/Magnetic'
import SlidingImages from '../components/SlidingImages'

const bgImages = [
  { img: bgImage1, id: 1 },
  { img: bgImage2, id: 2 },
  { img: bgImage3, id: 3 },
  { img: bgImage4, id: 4 },
  { img: bgImage5, id: 5 },
];

const images = [ img1, img2, img3, img4, img5, img6, img7, img8, img9, img10, img11, img12 ];

const Home = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex(prevIndex => (prevIndex + 1) % bgImages.length);
    }, 5000); 

    return () => clearInterval(interval);
  }, []);

  const firstText = useRef(null);
  const secondText = useRef(null);
  const slider = useRef(null);
  let xPercent = 0;
  let direction = -1;

  const textRef = useRef(null);
  const textRef2 = useRef(null);
  const textRef3 = useRef(null);
  const galleryRef = useRef(null);

  const textRef4 = useRef(null);

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    gsap.to(slider.current, {
      scrollTrigger: {
        trigger: slider.current,
        scrub: 1,
        start: 'top top',
        end: () => `+=${slider.current.offsetHeight}`,
        onUpdate: e => direction = e.direction * -1
      },
      x: "-500px",
    });

    const animation = () => {
      if (xPercent < -100) {
        xPercent = 0;
      } else if (xPercent > 0) {
        xPercent = -100;
      }
      gsap.set(firstText.current, { xPercent: xPercent });
      gsap.set(secondText.current, { xPercent: xPercent });
      xPercent += 0.1 * direction;
      requestAnimationFrame(animation);
    };

    requestAnimationFrame(animation);

    // Splitting the txt into single ch
    const splitText = new SplitType(textRef.current, { types: 'chars' });

    // Animating chs
    gsap.fromTo(splitText.chars, {
      y: '100%',
      opacity: 0
    }, {
      y: '0%',
      opacity: 1,
      stagger: 0.05,
      duration: 0.6,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: textRef.current,
        start: 'top 80%',
        end: 'top 20%',
        scrub: 1,
        markers: false,
        toggleActions: 'play none none reverse'
      }
    });

    // splitting the gallery h1 into individual chs
    const splitText2 = new SplitType(textRef2.current, { types: 'chars' });

    // Animating gallery h1 chs
    gsap.fromTo(splitText2.chars, {
      y: '200%',
      opacity: 0
    }, {
      y: '0%',
      opacity: 1,
      stagger: 0.05,
      duration: 0.6,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: textRef2.current,
        start: 'top 80%',
        end: 'top 20%',
        scrub: 1,
        markers: false,
        toggleActions: 'play none none reverse'
      }
    });

    // splitting the gallery p into individual chs
    const splitText3 = new SplitType(textRef3.current, { types: 'chars' });

    // Animating gallery p chs
    gsap.fromTo(splitText3.chars, {
      y: '200%',
      opacity: 0
    }, {
      y: '0%',
      opacity: 1,
      stagger: 0.05,
      duration: 0.6,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: textRef3.current,
        start: 'top 80%',
        end: 'top 20%',
        scrub: 1,
        markers: false,
        toggleActions: 'play none none reverse'
      }
    });

    // splitting the sliding h into individual chs
    const splitText4 = new SplitType(textRef4.current, { types: 'chars' });

    // Animating sliding h chs
    gsap.fromTo(splitText4.chars, {
      y: '200%',
      opacity: 0
    }, {
      y: '0%',
      opacity: 1,
      stagger: 0.05,
      duration: 0.6,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: textRef4.current,
        start: 'top 80%',
        end: 'top 20%',
        scrub: 1,
        markers: false,
        toggleActions: 'play none none reverse'
      }
    });
  }, []);

  const groupImages = (images, itemsPerRow) => {
    const rows = [];
    for (let i = 0; i < images.length; i += itemsPerRow) {
      rows.push(images.slice(i, i + itemsPerRow));
    }
    return rows;
  };

  const rows = groupImages(images, 3);

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    gsap.fromTo(
      '.img', 
      {
        opacity: 0,
        y: 200,
      },
      {
        opacity: 1,
        y: 0,
        duration: 8,
        stagger: 1,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: galleryRef.current,
          start: 'top 80%',
          end: 'top 20%',
          scrub: 5,
        }
      }
    );

    return () => {
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  }, []);

  return (
    <>
      <div className='home'>
        <div className='landing-page'>
          {bgImages.map((bgImage, index) => (
            <img
              className={`landing-page-bg-image ${index === currentImageIndex ? 'active' : ''}`}
              src={bgImage.img}
              key={bgImage.id}
              alt=''
            />
          ))}
        </div>
        <div className='sliderContainer'>
          <div ref={slider} className='slider'>
            <p ref={firstText}>GAMERS PARADISE -</p>
            <p ref={secondText}>GAMERS PARADISE -</p>
          </div>
        </div>
      </div>
      <div className='content'>
        <h1 ref={textRef}>
          Dive into a <span>WORLD</span> of Adventure
        </h1>
      </div>
      <div>
        <Earth />
      </div>
      <div className='content'>
        <h1 ref={textRef2}>
          Unleash Your <span>Gaming Potential</span> -with Top PC Games
        </h1>
      </div>
        <p className='gallery-para' ref={textRef3}>"Step into the world of top-tier <span>PC games.</span> Experience the graphics, gameplay, and stories that define <span>modern gaming.</span>"</p>
      <main className={styles.main} ref={galleryRef}>
        <div className={styles.gallery} >
          {rows.map((row, rowIndex) => (
            <div key={rowIndex} className={styles.row}>
              {row.map((src, imgIndex) => (
                <div key={imgIndex} className={`${styles.imageContainer} img`}>
                <Magnetic>
                  <img src={src} alt={`image-${rowIndex}-${imgIndex}`} />
                </Magnetic>  
                </div>
              ))}
            </div>
          ))}
        </div>
      </main>
      <div className='sliding-images-heading-container'>
      <h1 ref={textRef4}>Explore <span>MORE+</span></h1>
      </div>
      <SlidingImages />
    </>
  );
}

export default Home;
